import React from 'react';
import { Layout, GetInfo } from '../components';
import '../assets/styles/containers/Categories.sass';

const Categories = () => {
  return (
    <div className="Categories">
      <Layout bannerId={69}>
        <div className="container">
          <GetInfo id={136}/>
        </div>
      </Layout>
    </div>
  );
};

export default Categories;
